<ng-content>
  <!-- wrapping component should define <kendo-grid-column> elements to go here -->
</ng-content>
